import { render, staticRenderFns } from "./ProviderDetail.vue?vue&type=template&id=3967005a&scoped=true"
import script from "./ProviderDetail.vue?vue&type=script&lang=js"
export * from "./ProviderDetail.vue?vue&type=script&lang=js"
import style0 from "./ProviderDetail.vue?vue&type=style&index=0&id=3967005a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967005a",
  null
  
)

export default component.exports